import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import SalesMonitoringResults from './SalesMonitoringResults';
import LotterySearchModal from '../../components/LotterySearchModal';
import DateField from '../../components/DateField';
import ScopeField from '../../components/ScopeField';
import { resolveLotteryByCode } from '../../utils/lotteryLookup';
import { todayISO } from '../../utils/date';
import './SalesMonitoringPage.css';

const SalesMonitoringPage = () => {
  const [showResults, setShowResults] = useState(false);
  const [showLotteryModal, setShowLotteryModal] = useState(false);
  const [filter, setFilter] = useState('All');
  const [scopeId, setScopeId] = useState('');
  const [scopeName, setScopeName] = useState('');
  const [date, setDate] = useState(todayISO());
  const [refreshEvery, setRefreshEvery] = useState('120');
  const [lottery, setLottery] = useState('1');
  const [lotteryName, setLotteryName] = useState('');
  const [lotteryLookupError, setLotteryLookupError] = useState('');
  const [multipleTabs, setMultipleTabs] = useState(false);
  const [zoneId, setZoneId] = useState('0');

  const handleFilterChange = (opt) => {
    setFilter(opt);
    setScopeId('');
    setScopeName('');
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setShowResults(true);
  };

  // Affiche le nom de la loterie par défaut, et le rafraîchit quand on quitte le
  // champ après avoir tapé un code.
  useEffect(() => {
    resolveLotteryByCode(lottery).then((r) => { if (r) setLotteryName(r.name); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLotteryBlur = async () => {
    const c = String(lottery).trim();
    if (c === '') { setLotteryLookupError(''); return; }
    const res = await resolveLotteryByCode(c);
    if (res) {
      setLottery(res.code);
      setLotteryName(res.name);
      setLotteryLookupError('');
    } else {
      setLotteryLookupError('Loterie introuvable');
    }
  };

  if (showResults) {
    return (
      <SalesMonitoringResults
        date={date}
        tirage={lottery}
        filter={filter}
        scopeId={scopeId}
        onBack={() => setShowResults(false)}
      />
    );
  }

  return (
    <Layout>
      <p className="sm-breadcrumb">
        Ruta : <Link to="/dashboard" className="bc-link">Menu</Link>
        {' >> '}
        <Link to="/central" className="bc-link">Central</Link>
        {' >> '}
        <Link to="/sales-monitoring" className="bc-link">Sales Monitoring</Link>
      </p>

      <div className="sm-card">
        <div className="sm-card-header">
          <span className="sm-card-title">Sales Monitoring</span>
        </div>
        <div className="sm-card-body">
          <div className="sm-radio-row">
            {['All', 'Group', 'Supervisor', 'Bank'].map((opt) => (
              <label key={opt} className="sm-radio-label">
                <input
                  type="radio"
                  name="filter"
                  value={opt}
                  checked={filter === opt}
                  onChange={() => handleFilterChange(opt)}
                />
                {opt}
              </label>
            ))}
          </div>

          {filter !== 'All' && (
            <div className="sm-row sm-scope-row">
              <label className="sm-label">{filter}</label>
              <ScopeField
                filter={filter}
                id={scopeId}
                name={scopeName}
                onResolve={(id, nm) => { setScopeId(id); setScopeName(nm); }}
                inputClass="sm-input sm-input-sm"
                iconClass="sm-icon-btn"
                nameClass="sm-scope-name"
              />
            </div>
          )}

          <form onSubmit={handleSearch} className="sm-form">
            <div className="sm-row">
              <label className="sm-label">Date</label>
              <DateField className="sm-input sm-input-date" value={date} onChange={setDate} />
              <label className="sm-label sm-label-gap">Refresh Every</label>
              <input className="sm-input sm-input-sm" type="text" value={refreshEvery} onChange={e => setRefreshEvery(e.target.value)} />
              <span className="sm-unit">Scds.</span>
            </div>

            <div className="sm-row">
              <label className="sm-label">Lottery</label>
              <input
                className="sm-input sm-input-sm"
                type="text"
                inputMode="numeric"
                value={lottery}
                onChange={e => { setLottery(e.target.value); setLotteryLookupError(''); }}
                onFocus={e => e.target.select()}
                onBlur={handleLotteryBlur}
              />
              <span className="sm-icon sm-icon-btn" onClick={() => setShowLotteryModal(true)}>🔍</span>
              {lotteryLookupError
                ? <span className="sm-scope-name sm-lookup-err">{lotteryLookupError}</span>
                : lotteryName && <span className="sm-scope-name">{lotteryName}</span>}
            </div>

            {showLotteryModal && (
              <LotterySearchModal
                onSelect={(code, name) => {
                  setLottery(String(code));
                  setLotteryName(name || '');
                  setLotteryLookupError('');
                }}
                onClose={() => setShowLotteryModal(false)}
              />
            )}

            <div className="sm-row">
              <label className="sm-label">Multiple Tabs</label>
              <input type="checkbox" checked={multipleTabs} onChange={e => setMultipleTabs(e.target.checked)} />
            </div>

            <div className="sm-row">
              <label className="sm-label">Zone ID</label>
              <input className="sm-input sm-input-sm" type="text" value={zoneId} onChange={e => setZoneId(e.target.value)} />
              <span className="sm-icon">🔍</span>
            </div>

            <button type="submit" className="sm-search-btn">Search</button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default SalesMonitoringPage;
